import { FRAME_CLASSIFICATION_ID, TASK_CLASSIFICATION_ID } from './constants';
export const isClassificationAnnotationId = (id: string | undefined): boolean => id === TASK_CLASSIFICATION_ID || id === FRAME_CLASSIFICATION_ID;